import moment from "moment";
import { Link, Snack, TableBuilder } from "@tblabs/truffle";
import { Router } from "../Services/Router";
import { JobOffer } from "../Models/JobOffer";
import { Box } from "../Components/Box";
import { ApplyForm } from "../Models/ApplyForm";
import { Page } from "./Page";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Panel } from "../Components/Panel";
import { OffersRepo } from "../Services/OffersRepo";
import { ApplysRepo } from "../Services/ApplysRepo";


export class AdminMainPage extends Page
{
    constructor(
        private _offers: OffersRepo,
        private _applys: ApplysRepo,
        private _router: Router)
    {
        super("Oferty pracy oraz kandydatury");

        this.Content(async () =>
        {
            await Promise.all([this._offers.Init(), this._applys.Init()]);

            this.body.Append(
                new Panel("Wakaty", [
                    new TableBuilder(this._offers.Items)
                        .AddColumn("Stanowisko", x => new Link(x.Title.value).OnClick(() => this._router.GoToOfferView(x)))
                        .AddColumn("Rekrutacja", x => x.IsRecruitmentOpen.value ? "✅ Otwarta" : "🔒 Zamknięta")
                        .AddColumn("Opcje", x => [
                            new Link("👀")
                                .OnClick(() => this._router.GoToOfferView(x)),
                            _offers.CanUser("UpdateFile") && new Link("📝").MarginLeft(12)
                                .OnClick(() => this._router.GoToOfferEdit(x)),
                            _offers.CanUser("DeleteFile") && new Link("❌").MarginLeft(12)
                                .OnClick(async () => this.RemoveOffer(x)),
                        ])
                        .Build(),
                    new Box(
                        new PrimaryButton("➕ Dodaj")
                            .OnClick(async () => await this._offers.Add(new JobOffer()))
                    )]),

                new Panel("Kandydatury", [
                    new TableBuilder(this._applys.Items)
                        .AddColumn("Kandydat", x => [
                            new Link(x.Recruit.Name.value).OnClick(() => this._router.GoToApplyView(x)),
                            "\n"+x.Recruit.City.value
                        ])
                        .AddColumn("Stanowisko", x => x.Position)
                        .AddColumn("Kontakt", x => `${x.Recruit.Phone.value} / ${x.Recruit.Email.value}`)
                        .AddColumn("Złożone", x => +x.CreatedAt?.getTime() > 0 ? moment(x.CreatedAt).format("DD.MM.YYYY") : "brak daty")
                        .AddColumn("Opcje", x => [
                           _applys.CanUser("DeleteFile") && new Link("❌").MarginLeft(12)
                                .OnClick(async () => this.RemoveApply(x)),
                        ])
                        .Build(),
                ]))
        });
    }

    private async RemoveOffer(offer: JobOffer): Promise<void>
    {
        if (confirm(`Usunąć ${offer.Title.value}?`))
        {
            try
            {
                await this._offers.Delete(offer);

                new Snack("✅ Oferta usunięta");
            }
            catch (ex: any)
            {
                new Snack("❌ Błąd usuwania oferty", ex.message);
            }
        }
    }

    private async RemoveApply(apply: ApplyForm): Promise<void>
    {
        if (confirm(`Usunąć kandydaturę ${apply.Position}?`))
        {
            try
            {
                await this._applys.Delete(apply);

                new Snack("✅ Kandydatura usunięta");
            }
            catch (ex: any)
            {
                new Snack("❌ Błąd usuwania kandydatury", ex.message);
            }
        }
    }
}
